var map = {
	"./af": 98503,
	"./af.d": 56022,
	"./af.d.ts": 56022,
	"./af.js": 98503,
	"./ak": 18482,
	"./ak.d": 86276,
	"./ak.d.ts": 86276,
	"./ak.js": 18482,
	"./am": 68917,
	"./am.d": 93575,
	"./am.d.ts": 93575,
	"./am.js": 68917,
	"./an": 90542,
	"./an.d": 58978,
	"./an.d.ts": 58978,
	"./an.js": 90542,
	"./ar": 75466,
	"./ar.d": 48951,
	"./ar.d.ts": 48951,
	"./ar.js": 75466,
	"./ars": 48253,
	"./ars.d": 98039,
	"./ars.d.ts": 98039,
	"./ars.js": 48253,
	"./as": 35407,
	"./as.d": 40560,
	"./as.d.ts": 40560,
	"./as.js": 35407,
	"./asa": 54597,
	"./asa.d": 1604,
	"./asa.d.ts": 1604,
	"./asa.js": 54597,
	"./ast": 51651,
	"./ast.d": 12216,
	"./ast.d.ts": 12216,
	"./ast.js": 51651,
	"./az": 28612,
	"./az.d": 44774,
	"./az.d.ts": 44774,
	"./az.js": 28612,
	"./bal": 77255,
	"./bal.d": 49425,
	"./bal.d.ts": 49425,
	"./bal.js": 77255,
	"./be": 62407,
	"./be.d": 91071,
	"./be.d.ts": 91071,
	"./be.js": 62407,
	"./bem": 98184,
	"./bem.d": 57393,
	"./bem.d.ts": 57393,
	"./bem.js": 98184,
	"./bez": 58130,
	"./bez.d": 90519,
	"./bez.d.ts": 90519,
	"./bez.js": 58130,
	"./bg": 60335,
	"./bg.d": 80517,
	"./bg.d.ts": 80517,
	"./bg.js": 60335,
	"./bho": 89196,
	"./bho.d": 13642,
	"./bho.d.ts": 13642,
	"./bho.js": 89196,
	"./bm": 1050,
	"./bm.d": 33697,
	"./bm.d.ts": 33697,
	"./bm.js": 1050,
	"./bn": 47712,
	"./bn.d": 7742,
	"./bn.d.ts": 7742,
	"./bn.js": 47712,
	"./bo": 42602,
	"./bo.d": 99200,
	"./bo.d.ts": 99200,
	"./bo.js": 42602,
	"./br": 76035,
	"./br.d": 88174,
	"./br.d.ts": 88174,
	"./br.js": 76035,
	"./brx": 68172,
	"./brx.d": 64024,
	"./brx.d.ts": 64024,
	"./brx.js": 68172,
	"./bs": 52778,
	"./bs.d": 65458,
	"./bs.d.ts": 65458,
	"./bs.js": 52778,
	"./ca": 37179,
	"./ca.d": 7233,
	"./ca.d.ts": 7233,
	"./ca.js": 37179,
	"./ce": 11223,
	"./ce.d": 95655,
	"./ce.d.ts": 95655,
	"./ce.js": 11223,
	"./ceb": 36630,
	"./ceb.d": 44789,
	"./ceb.d.ts": 44789,
	"./ceb.js": 36630,
	"./cgg": 29219,
	"./cgg.d": 53031,
	"./cgg.d.ts": 53031,
	"./cgg.js": 29219,
	"./chr": 19943,
	"./chr.d": 7447,
	"./chr.d.ts": 7447,
	"./chr.js": 19943,
	"./ckb": 35319,
	"./ckb.d": 73881,
	"./ckb.d.ts": 73881,
	"./ckb.js": 35319,
	"./cs": 36508,
	"./cs.d": 62644,
	"./cs.d.ts": 62644,
	"./cs.js": 36508,
	"./cy": 66109,
	"./cy.d": 75069,
	"./cy.d.ts": 75069,
	"./cy.js": 66109,
	"./da": 43793,
	"./da.d": 52030,
	"./da.d.ts": 52030,
	"./da.js": 43793,
	"./de": 26137,
	"./de.d": 96877,
	"./de.d.ts": 96877,
	"./de.js": 26137,
	"./doi": 34702,
	"./doi.d": 19985,
	"./doi.d.ts": 19985,
	"./doi.js": 34702,
	"./dsb": 17995,
	"./dsb.d": 51549,
	"./dsb.d.ts": 51549,
	"./dsb.js": 17995,
	"./dv": 87000,
	"./dv.d": 31501,
	"./dv.d.ts": 31501,
	"./dv.js": 87000,
	"./dz": 96077,
	"./dz.d": 24314,
	"./dz.d.ts": 24314,
	"./dz.js": 96077,
	"./ee": 4494,
	"./ee.d": 33247,
	"./ee.d.ts": 33247,
	"./ee.js": 4494,
	"./el": 85511,
	"./el.d": 20779,
	"./el.d.ts": 20779,
	"./el.js": 85511,
	"./en": 14331,
	"./en.d": 36552,
	"./en.d.ts": 36552,
	"./en.js": 14331,
	"./eo": 56795,
	"./eo.d": 25707,
	"./eo.d.ts": 25707,
	"./eo.js": 56795,
	"./es": 88852,
	"./es.d": 7943,
	"./es.d.ts": 7943,
	"./es.js": 88852,
	"./et": 91466,
	"./et.d": 89250,
	"./et.d.ts": 89250,
	"./et.js": 91466,
	"./eu": 85521,
	"./eu.d": 47225,
	"./eu.d.ts": 47225,
	"./eu.js": 85521,
	"./fa": 96405,
	"./fa.d": 28527,
	"./fa.d.ts": 28527,
	"./fa.js": 96405,
	"./ff": 29886,
	"./ff.d": 87557,
	"./ff.d.ts": 87557,
	"./ff.js": 29886,
	"./fi": 13996,
	"./fi.d": 56993,
	"./fi.d.ts": 56993,
	"./fi.js": 13996,
	"./fil": 42655,
	"./fil.d": 4613,
	"./fil.d.ts": 4613,
	"./fil.js": 42655,
	"./fo": 62398,
	"./fo.d": 81556,
	"./fo.d.ts": 81556,
	"./fo.js": 62398,
	"./fr": 96568,
	"./fr.d": 11479,
	"./fr.d.ts": 11479,
	"./fr.js": 96568,
	"./fur": 26025,
	"./fur.d": 31929,
	"./fur.d.ts": 31929,
	"./fur.js": 26025,
	"./fy": 33322,
	"./fy.d": 37140,
	"./fy.d.ts": 37140,
	"./fy.js": 33322,
	"./ga": 13649,
	"./ga.d": 62964,
	"./ga.d.ts": 62964,
	"./ga.js": 13649,
	"./gd": 22834,
	"./gd.d": 69631,
	"./gd.d.ts": 69631,
	"./gd.js": 22834,
	"./gl": 36918,
	"./gl.d": 41144,
	"./gl.d.ts": 41144,
	"./gl.js": 36918,
	"./gsw": 33334,
	"./gsw.d": 58917,
	"./gsw.d.ts": 58917,
	"./gsw.js": 33334,
	"./gu": 27991,
	"./gu.d": 33712,
	"./gu.d.ts": 33712,
	"./gu.js": 27991,
	"./guw": 21812,
	"./guw.d": 24812,
	"./guw.d.ts": 24812,
	"./guw.js": 21812,
	"./gv": 98606,
	"./gv.d": 77786,
	"./gv.d.ts": 77786,
	"./gv.js": 98606,
	"./ha": 22771,
	"./ha.d": 46198,
	"./ha.d.ts": 46198,
	"./ha.js": 22771,
	"./haw": 43572,
	"./haw.d": 67822,
	"./haw.d.ts": 67822,
	"./haw.js": 43572,
	"./he": 31467,
	"./he.d": 49556,
	"./he.d.ts": 49556,
	"./he.js": 31467,
	"./hi": 10343,
	"./hi.d": 94210,
	"./hi.d.ts": 94210,
	"./hi.js": 10343,
	"./hnj": 29356,
	"./hnj.d": 19071,
	"./hnj.d.ts": 19071,
	"./hnj.js": 29356,
	"./hr": 28887,
	"./hr.d": 85766,
	"./hr.d.ts": 85766,
	"./hr.js": 28887,
	"./hsb": 71840,
	"./hsb.d": 44377,
	"./hsb.d.ts": 44377,
	"./hsb.js": 71840,
	"./hu": 2447,
	"./hu.d": 51141,
	"./hu.d.ts": 51141,
	"./hu.js": 2447,
	"./hy": 34013,
	"./hy.d": 83417,
	"./hy.d.ts": 83417,
	"./hy.js": 34013,
	"./ia": 71706,
	"./ia.d": 85537,
	"./ia.d.ts": 85537,
	"./ia.js": 71706,
	"./id": 40786,
	"./id.d": 67844,
	"./id.d.ts": 67844,
	"./id.js": 40786,
	"./ig": 66572,
	"./ig.d": 95695,
	"./ig.d.ts": 95695,
	"./ig.js": 66572,
	"./ii": 30994,
	"./ii.d": 63608,
	"./ii.d.ts": 63608,
	"./ii.js": 30994,
	"./io": 34122,
	"./io.d": 8333,
	"./io.d.ts": 8333,
	"./io.js": 34122,
	"./is": 1488,
	"./is.d": 28687,
	"./is.d.ts": 28687,
	"./is.js": 1488,
	"./it": 79333,
	"./it.d": 36175,
	"./it.d.ts": 36175,
	"./it.js": 79333,
	"./iu": 2969,
	"./iu.d": 54328,
	"./iu.d.ts": 54328,
	"./iu.js": 2969,
	"./ja": 43836,
	"./ja.d": 28767,
	"./ja.d.ts": 28767,
	"./ja.js": 43836,
	"./jbo": 64510,
	"./jbo.d": 43667,
	"./jbo.d.ts": 43667,
	"./jbo.js": 64510,
	"./jgo": 45303,
	"./jgo.d": 16838,
	"./jgo.d.ts": 16838,
	"./jgo.js": 45303,
	"./jmc": 44162,
	"./jmc.d": 36008,
	"./jmc.d.ts": 36008,
	"./jmc.js": 44162,
	"./jv": 79503,
	"./jv.d": 47046,
	"./jv.d.ts": 47046,
	"./jv.js": 79503,
	"./jw": 8961,
	"./jw.d": 74952,
	"./jw.d.ts": 74952,
	"./jw.js": 8961,
	"./ka": 15114,
	"./ka.d": 18438,
	"./ka.d.ts": 18438,
	"./ka.js": 15114,
	"./kab": 24017,
	"./kab.d": 27714,
	"./kab.d.ts": 27714,
	"./kab.js": 24017,
	"./kaj": 86467,
	"./kaj.d": 66239,
	"./kaj.d.ts": 66239,
	"./kaj.js": 86467,
	"./kcg": 51979,
	"./kcg.d": 82553,
	"./kcg.d.ts": 82553,
	"./kcg.js": 51979,
	"./kde": 7554,
	"./kde.d": 64404,
	"./kde.d.ts": 64404,
	"./kde.js": 7554,
	"./kea": 82863,
	"./kea.d": 88412,
	"./kea.d.ts": 88412,
	"./kea.js": 82863,
	"./kk": 73467,
	"./kk.d": 45770,
	"./kk.d.ts": 45770,
	"./kk.js": 73467,
	"./kkj": 73245,
	"./kkj.d": 47189,
	"./kkj.d.ts": 47189,
	"./kkj.js": 73245,
	"./kl": 21720,
	"./kl.d": 74233,
	"./kl.d.ts": 74233,
	"./kl.js": 21720,
	"./km": 54971,
	"./km.d": 95223,
	"./km.d.ts": 95223,
	"./km.js": 54971,
	"./kn": 18785,
	"./kn.d": 55144,
	"./kn.d.ts": 55144,
	"./kn.js": 18785,
	"./ko": 41650,
	"./ko.d": 81576,
	"./ko.d.ts": 81576,
	"./ko.js": 41650,
	"./ks": 21306,
	"./ks.d": 9812,
	"./ks.d.ts": 9812,
	"./ks.js": 21306,
	"./ksb": 68986,
	"./ksb.d": 89566,
	"./ksb.d.ts": 89566,
	"./ksb.js": 68986,
	"./ksh": 18207,
	"./ksh.d": 79075,
	"./ksh.d.ts": 79075,
	"./ksh.js": 18207,
	"./ku": 34924,
	"./ku.d": 30398,
	"./ku.d.ts": 30398,
	"./ku.js": 34924,
	"./kw": 38138,
	"./kw.d": 48515,
	"./kw.d.ts": 48515,
	"./kw.js": 38138,
	"./ky": 70730,
	"./ky.d": 18527,
	"./ky.d.ts": 18527,
	"./ky.js": 70730,
	"./lag": 87372,
	"./lag.d": 40153,
	"./lag.d.ts": 40153,
	"./lag.js": 87372,
	"./lb": 89056,
	"./lb.d": 17465,
	"./lb.d.ts": 17465,
	"./lb.js": 89056,
	"./lg": 72976,
	"./lg.d": 85120,
	"./lg.d.ts": 85120,
	"./lg.js": 72976,
	"./lij": 15046,
	"./lij.d": 6190,
	"./lij.d.ts": 6190,
	"./lij.js": 15046,
	"./lkt": 52,
	"./lkt.d": 3230,
	"./lkt.d.ts": 3230,
	"./lkt.js": 52,
	"./ln": 73700,
	"./ln.d": 28131,
	"./ln.d.ts": 28131,
	"./ln.js": 73700,
	"./lo": 1394,
	"./lo.d": 60423,
	"./lo.d.ts": 60423,
	"./lo.js": 1394,
	"./lt": 33278,
	"./lt.d": 90710,
	"./lt.d.ts": 90710,
	"./lt.js": 33278,
	"./lv": 61217,
	"./lv.d": 16835,
	"./lv.d.ts": 16835,
	"./lv.js": 61217,
	"./mas": 50630,
	"./mas.d": 27898,
	"./mas.d.ts": 27898,
	"./mas.js": 50630,
	"./mg": 36970,
	"./mg.d": 90243,
	"./mg.d.ts": 90243,
	"./mg.js": 36970,
	"./mgo": 77642,
	"./mgo.d": 22644,
	"./mgo.d.ts": 22644,
	"./mgo.js": 77642,
	"./mk": 54823,
	"./mk.d": 42556,
	"./mk.d.ts": 42556,
	"./mk.js": 54823,
	"./ml": 36524,
	"./ml.d": 96416,
	"./ml.d.ts": 96416,
	"./ml.js": 36524,
	"./mn": 40544,
	"./mn.d": 35644,
	"./mn.d.ts": 35644,
	"./mn.js": 40544,
	"./mo": 376,
	"./mo.d": 77641,
	"./mo.d.ts": 77641,
	"./mo.js": 376,
	"./mr": 93613,
	"./mr.d": 31910,
	"./mr.d.ts": 31910,
	"./mr.js": 93613,
	"./ms": 12646,
	"./ms.d": 56524,
	"./ms.d.ts": 56524,
	"./ms.js": 12646,
	"./mt": 13049,
	"./mt.d": 86738,
	"./mt.d.ts": 86738,
	"./mt.js": 13049,
	"./my": 51380,
	"./my.d": 79324,
	"./my.d.ts": 79324,
	"./my.js": 51380,
	"./nah": 27497,
	"./nah.d": 6294,
	"./nah.d.ts": 6294,
	"./nah.js": 27497,
	"./naq": 57775,
	"./naq.d": 52561,
	"./naq.d.ts": 52561,
	"./naq.js": 57775,
	"./nb": 18026,
	"./nb.d": 68293,
	"./nb.d.ts": 68293,
	"./nb.js": 18026,
	"./nd": 22181,
	"./nd.d": 29342,
	"./nd.d.ts": 29342,
	"./nd.js": 22181,
	"./ne": 945,
	"./ne.d": 86991,
	"./ne.d.ts": 86991,
	"./ne.js": 945,
	"./nl": 58169,
	"./nl.d": 90896,
	"./nl.d.ts": 90896,
	"./nl.js": 58169,
	"./nn": 35436,
	"./nn.d": 91499,
	"./nn.d.ts": 91499,
	"./nn.js": 35436,
	"./nnh": 61423,
	"./nnh.d": 42571,
	"./nnh.d.ts": 42571,
	"./nnh.js": 61423,
	"./no": 42724,
	"./no.d": 51397,
	"./no.d.ts": 51397,
	"./no.js": 42724,
	"./nqo": 49119,
	"./nqo.d": 75753,
	"./nqo.d.ts": 75753,
	"./nqo.js": 49119,
	"./nr": 90248,
	"./nr.d": 17330,
	"./nr.d.ts": 17330,
	"./nr.js": 90248,
	"./nso": 50010,
	"./nso.d": 28595,
	"./nso.d.ts": 28595,
	"./nso.js": 50010,
	"./ny": 56950,
	"./ny.d": 92070,
	"./ny.d.ts": 92070,
	"./ny.js": 56950,
	"./nyn": 57376,
	"./nyn.d": 84409,
	"./nyn.d.ts": 84409,
	"./nyn.js": 57376,
	"./om": 52368,
	"./om.d": 36564,
	"./om.d.ts": 36564,
	"./om.js": 52368,
	"./or": 62943,
	"./or.d": 5853,
	"./or.d.ts": 5853,
	"./or.js": 62943,
	"./os": 11665,
	"./os.d": 92039,
	"./os.d.ts": 92039,
	"./os.js": 11665,
	"./osa": 80079,
	"./osa.d": 48205,
	"./osa.d.ts": 48205,
	"./osa.js": 80079,
	"./pa": 11042,
	"./pa.d": 93621,
	"./pa.d.ts": 93621,
	"./pa.js": 11042,
	"./pap": 99524,
	"./pap.d": 63090,
	"./pap.d.ts": 63090,
	"./pap.js": 99524,
	"./pcm": 23381,
	"./pcm.d": 85437,
	"./pcm.d.ts": 85437,
	"./pcm.js": 23381,
	"./pl": 12805,
	"./pl.d": 25126,
	"./pl.d.ts": 25126,
	"./pl.js": 12805,
	"./prg": 4600,
	"./prg.d": 87099,
	"./prg.d.ts": 87099,
	"./prg.js": 4600,
	"./ps": 2465,
	"./ps.d": 72816,
	"./ps.d.ts": 72816,
	"./ps.js": 2465,
	"./pt": 63451,
	"./pt-PT": 73288,
	"./pt-PT.d": 42831,
	"./pt-PT.d.ts": 42831,
	"./pt-PT.js": 73288,
	"./pt.d": 85159,
	"./pt.d.ts": 85159,
	"./pt.js": 63451,
	"./rm": 59124,
	"./rm.d": 19220,
	"./rm.d.ts": 19220,
	"./rm.js": 59124,
	"./ro": 76852,
	"./ro.d": 33270,
	"./ro.d.ts": 33270,
	"./ro.js": 76852,
	"./rof": 68608,
	"./rof.d": 87848,
	"./rof.d.ts": 87848,
	"./rof.js": 68608,
	"./ru": 58571,
	"./ru.d": 42524,
	"./ru.d.ts": 42524,
	"./ru.js": 58571,
	"./rwk": 14146,
	"./rwk.d": 46128,
	"./rwk.d.ts": 46128,
	"./rwk.js": 14146,
	"./sah": 22882,
	"./sah.d": 82369,
	"./sah.d.ts": 82369,
	"./sah.js": 22882,
	"./saq": 16648,
	"./saq.d": 22708,
	"./saq.d.ts": 22708,
	"./saq.js": 16648,
	"./sat": 65425,
	"./sat.d": 82575,
	"./sat.d.ts": 82575,
	"./sat.js": 65425,
	"./sc": 96502,
	"./sc.d": 50906,
	"./sc.d.ts": 50906,
	"./sc.js": 96502,
	"./scn": 92696,
	"./scn.d": 21542,
	"./scn.d.ts": 21542,
	"./scn.js": 92696,
	"./sd": 36841,
	"./sd.d": 96524,
	"./sd.d.ts": 96524,
	"./sd.js": 36841,
	"./sdh": 76642,
	"./sdh.d": 11329,
	"./sdh.d.ts": 11329,
	"./sdh.js": 76642,
	"./se": 1127,
	"./se.d": 88211,
	"./se.d.ts": 88211,
	"./se.js": 1127,
	"./seh": 11982,
	"./seh.d": 1097,
	"./seh.d.ts": 1097,
	"./seh.js": 11982,
	"./ses": 98913,
	"./ses.d": 5135,
	"./ses.d.ts": 5135,
	"./ses.js": 98913,
	"./sg": 84608,
	"./sg.d": 45658,
	"./sg.d.ts": 45658,
	"./sg.js": 84608,
	"./sh": 84849,
	"./sh.d": 39149,
	"./sh.d.ts": 39149,
	"./sh.js": 84849,
	"./shi": 49608,
	"./shi.d": 47372,
	"./shi.d.ts": 47372,
	"./shi.js": 49608,
	"./si": 2714,
	"./si.d": 6653,
	"./si.d.ts": 6653,
	"./si.js": 2714,
	"./sk": 75308,
	"./sk.d": 41835,
	"./sk.d.ts": 41835,
	"./sk.js": 75308,
	"./sl": 80462,
	"./sl.d": 43479,
	"./sl.d.ts": 43479,
	"./sl.js": 80462,
	"./sma": 19210,
	"./sma.d": 18661,
	"./sma.d.ts": 18661,
	"./sma.js": 19210,
	"./smi": 70864,
	"./smi.d": 75357,
	"./smi.d.ts": 75357,
	"./smi.js": 70864,
	"./smj": 14373,
	"./smj.d": 50484,
	"./smj.d.ts": 50484,
	"./smj.js": 14373,
	"./smn": 5710,
	"./smn.d": 27795,
	"./smn.d.ts": 27795,
	"./smn.js": 5710,
	"./sms": 53318,
	"./sms.d": 73623,
	"./sms.d.ts": 73623,
	"./sms.js": 53318,
	"./sn": 4536,
	"./sn.d": 4417,
	"./sn.d.ts": 4417,
	"./sn.js": 4536,
	"./so": 72102,
	"./so.d": 24459,
	"./so.d.ts": 24459,
	"./so.js": 72102,
	"./sq": 11907,
	"./sq.d": 74408,
	"./sq.d.ts": 74408,
	"./sq.js": 11907,
	"./sr": 66250,
	"./sr.d": 64901,
	"./sr.d.ts": 64901,
	"./sr.js": 66250,
	"./ss": 62814,
	"./ss.d": 39879,
	"./ss.d.ts": 39879,
	"./ss.js": 62814,
	"./ssy": 27904,
	"./ssy.d": 28400,
	"./ssy.d.ts": 28400,
	"./ssy.js": 27904,
	"./st": 54300,
	"./st.d": 50549,
	"./st.d.ts": 50549,
	"./st.js": 54300,
	"./su": 33847,
	"./su.d": 69337,
	"./su.d.ts": 69337,
	"./su.js": 33847,
	"./sv": 62841,
	"./sv.d": 65065,
	"./sv.d.ts": 65065,
	"./sv.js": 62841,
	"./sw": 76321,
	"./sw.d": 46509,
	"./sw.d.ts": 46509,
	"./sw.js": 76321,
	"./syr": 58290,
	"./syr.d": 23235,
	"./syr.d.ts": 23235,
	"./syr.js": 58290,
	"./ta": 39943,
	"./ta.d": 4880,
	"./ta.d.ts": 4880,
	"./ta.js": 39943,
	"./te": 11394,
	"./te.d": 14787,
	"./te.d.ts": 14787,
	"./te.js": 11394,
	"./teo": 18900,
	"./teo.d": 78099,
	"./teo.d.ts": 78099,
	"./teo.js": 18900,
	"./th": 85647,
	"./th.d": 94685,
	"./th.d.ts": 94685,
	"./th.js": 85647,
	"./ti": 39490,
	"./ti.d": 64946,
	"./ti.d.ts": 64946,
	"./ti.js": 39490,
	"./tig": 95729,
	"./tig.d": 72680,
	"./tig.d.ts": 72680,
	"./tig.js": 95729,
	"./tk": 64622,
	"./tk.d": 24110,
	"./tk.d.ts": 24110,
	"./tk.js": 64622,
	"./tl": 660,
	"./tl.d": 74909,
	"./tl.d.ts": 74909,
	"./tl.js": 660,
	"./tn": 21273,
	"./tn.d": 80085,
	"./tn.d.ts": 80085,
	"./tn.js": 21273,
	"./to": 60237,
	"./to.d": 85539,
	"./to.d.ts": 85539,
	"./to.js": 60237,
	"./tpi": 74146,
	"./tpi.d": 78274,
	"./tpi.d.ts": 78274,
	"./tpi.js": 74146,
	"./tr": 74685,
	"./tr.d": 80500,
	"./tr.d.ts": 80500,
	"./tr.js": 74685,
	"./ts": 5313,
	"./ts.d": 87306,
	"./ts.d.ts": 87306,
	"./ts.js": 5313,
	"./tzm": 19394,
	"./tzm.d": 46536,
	"./tzm.d.ts": 46536,
	"./tzm.js": 19394,
	"./ug": 81378,
	"./ug.d": 59860,
	"./ug.d.ts": 59860,
	"./ug.js": 81378,
	"./uk": 35088,
	"./uk.d": 22837,
	"./uk.d.ts": 22837,
	"./uk.js": 35088,
	"./und": 4142,
	"./und.d": 60427,
	"./und.d.ts": 60427,
	"./und.js": 4142,
	"./ur": 38365,
	"./ur.d": 10404,
	"./ur.d.ts": 10404,
	"./ur.js": 38365,
	"./uz": 54821,
	"./uz.d": 5584,
	"./uz.d.ts": 5584,
	"./uz.js": 54821,
	"./ve": 21315,
	"./ve.d": 59780,
	"./ve.d.ts": 59780,
	"./ve.js": 21315,
	"./vi": 4687,
	"./vi.d": 6721,
	"./vi.d.ts": 6721,
	"./vi.js": 4687,
	"./vo": 64142,
	"./vo.d": 65441,
	"./vo.d.ts": 65441,
	"./vo.js": 64142,
	"./vun": 62352,
	"./vun.d": 60079,
	"./vun.d.ts": 60079,
	"./vun.js": 62352,
	"./wa": 23911,
	"./wa.d": 24102,
	"./wa.d.ts": 24102,
	"./wa.js": 23911,
	"./wae": 94264,
	"./wae.d": 56179,
	"./wae.d.ts": 56179,
	"./wae.js": 94264,
	"./wo": 34683,
	"./wo.d": 55597,
	"./wo.d.ts": 55597,
	"./wo.js": 34683,
	"./xh": 35538,
	"./xh.d": 7370,
	"./xh.d.ts": 7370,
	"./xh.js": 35538,
	"./xog": 28161,
	"./xog.d": 34770,
	"./xog.d.ts": 34770,
	"./xog.js": 28161,
	"./yi": 20202,
	"./yi.d": 34829,
	"./yi.d.ts": 34829,
	"./yi.js": 20202,
	"./yo": 80801,
	"./yo.d": 96370,
	"./yo.d.ts": 96370,
	"./yo.js": 80801,
	"./yue": 51299,
	"./yue.d": 82177,
	"./yue.d.ts": 82177,
	"./yue.js": 51299,
	"./zh": 32677,
	"./zh.d": 14407,
	"./zh.d.ts": 14407,
	"./zh.js": 32677,
	"./zu": 46236,
	"./zu.d": 25772,
	"./zu.d.ts": 25772,
	"./zu.js": 46236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80740;